import { render, staticRenderFns } from "./Episode.vue?vue&type=template&id=fc161132"
import script from "./Episode.vue?vue&type=script&lang=js"
export * from "./Episode.vue?vue&type=script&lang=js"
import style0 from "./Episode.vue?vue&type=style&index=0&id=fc161132&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports